angular.module('app.filters')
.filter('filterOpportunities', [
  "$log", "$filter", 'sharedProperties', function($log, $filter, sharedProperties) {
    return function(filterPractice, filterLocation, filterPQE, firmsList) {
      var filteredFirms;
      filteredFirms = angular.copy(firmsList);
      if (sharedProperties.isNotNullOrEmpty(filterLocation) && filterLocation !== "All") {
        filteredFirms = $filter('filterLocations')(filteredFirms, filterLocation);
      }
      if (sharedProperties.isNotNullOrEmpty(filterPractice)) {
        filteredFirms = $filter('selectedTags')(filteredFirms, filterPractice);
      }
      if (!_.isNaN(filterPQE) && filterPQE !== "All") {
        filteredFirms = $filter('filterJobsByPQE')(filteredFirms, filterPQE);
      }
      return filteredFirms;
    };
  }
])


// WEBPACK FOOTER //
// ./scripts/shared/filters/opportunities.js